import { findIndex, clone } from 'lodash-es';
import draggable from 'vuedraggable';

let { events } = require('@tagboard/lib-analytics');

events = events({ plansAPI: process.env.PLANS_API });

export default {
  components: {
    draggable,
  },

  data() {
    return {
      searchTerms: [],
      searchResults: [],
      selected: [],
    };
  },

  created() {
    document.addEventListener('clearTabSelection', this.clearSelection);
  },

  beforeUnmount() {
    document.removeEventListener('clearTabSelection', this.clearSelection);
  },

  computed: {
    playing() {
      return this.production.playing;
    },

    production() {
      return this.$store.state.production.production;
    },

    allSelected() {
      return this.selected.length && this.selected.length === this.searchResults.length;
    },
  },

  methods: {
    clearSelection() {
      this.selected = [];
    },

    addTag(tag) {
      if (this.searchTerms.indexOf(tag) === -1) {
        this.searchTerms.push(tag);
        this.doSearch();
      }
    },

    removeTag(tag) {
      const index = findIndex(this.searchTerms, (o) => o === tag);
      this.searchTerms.splice(index, 1);
      this.doSearch();
    },

    toggleAll($event) {
      if (!$event.target.checked) {
        this.selected = [];
      } else {
        this.selected = clone(this.searchResults);
      }
    },

    addSelectedToPlaylist(type) {
      const items = this.selected.map((item) => this.clone(item));

      this.$store.dispatch('addLayouts', { items });

      this.selected = [];

      events.log({
        event: `Producer Added Multiple Playlist Items ${type}`,
        fields: {
          count: items.length,
          production_id: this.production._id,
        },
        ownerId: this.production.owner,
      });
    },

    addSelectedToGroup(type, parentTimelineId) {
      const items = this.selected.map((item) => this.clone(item));

      this.$store.dispatch('addLayouts', {
        parentId: parentTimelineId,
        items,
      });

      this.selected = [];

      if (items.length > 1) {
        events.log({
          event: 'Producer Added Multiple Graphics to Group from Menu',
          fields: {
            count: items.length,
            production_id: this.production._id,
          },
          ownerId: this.production.owner,
        });
      } else {
        events.log({
          event: 'Producer Added Graphic to Group from Menu',
          fields: {
            production_id: this.production._id,
          },
          ownerId: this.production.owner,
        });
      }
    },

    addToPlaylist(item, type) {
      this.$store.dispatch('addLayouts', { items: [this.clone(item)] });

      events.log({
        event: `Producer Added Playlist Item ${type}`,
        fields: {
          type,
          production_id: this.production._id,
        },
        ownerId: this.production.owner,
      });
    },
  },
};
